module.exports = __webpack_public_path__ + "assets/img/bannerBg.d0c9fc31.png";